module.exports = __webpack_public_path__ + "static/img/dby.c502387b.jpg";